var map = {
	"./3d.svg": "3491",
	"./add.svg": "76a4",
	"./ai.svg": "5b53",
	"./app.svg": "33c2",
	"./background.svg": "1473",
	"./camera.svg": "24e5",
	"./cashback.svg": "aac7",
	"./cashier.svg": "3749",
	"./catalogue.svg": "1f07",
	"./doodle.svg": "5f4b",
	"./down-arrow.svg": "fcc4",
	"./drag.svg": "88c6",
	"./drawing.svg": "fe72",
	"./dustbin.svg": "5540",
	"./infographic.svg": "d8ff",
	"./instagram.svg": "bd6c",
	"./instructions.svg": "ed7f",
	"./kiosk.svg": "2a5e",
	"./kiosk1.svg": "18b2",
	"./left-arrow.svg": "6d4b",
	"./loupe.svg": "f39b",
	"./manager.svg": "f955",
	"./mult.svg": "22b9",
	"./placeholder.svg": "0139",
	"./presentation.svg": "b097",
	"./quote.svg": "1636",
	"./search.svg": "d103",
	"./sells.svg": "a11e",
	"./startup.svg": "570c",
	"./table.svg": "979b",
	"./team.svg": "fb7c",
	"./turnstiles.svg": "6bb8",
	"./virus.svg": "34b2",
	"./vr.svg": "5bb7",
	"./web.svg": "72d5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";